import { render, staticRenderFns } from "./ChatRoom.vue?vue&type=template&id=e1338924&scoped=true"
import script from "./ChatRoom.vue?vue&type=script&lang=js"
export * from "./ChatRoom.vue?vue&type=script&lang=js"
import style0 from "./ChatRoom.vue?vue&type=style&index=0&id=e1338924&prod&lang=less&scoped=true"
import style1 from "./ChatRoom.vue?vue&type=style&index=1&id=e1338924&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1338924",
  null
  
)

export default component.exports